import { render, staticRenderFns } from "./WebPagesList.vue?vue&type=template&id=c554ab32&"
import script from "./WebPagesList.vue?vue&type=script&lang=js&"
export * from "./WebPagesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports